// These are imports that are needed on all (or most) of the pages
// Be careful when adding more imports here, because it might bloat the size of JS on all the pages

import "../app/flash"
import "../app/navigation"
import "../../../engines/notifications/javascript"
import "../app/shared/toaster"
import "../app/account/approval-banner"
import "../app/account/unconfirmed-user-email-banner"
import "../app/account/unconfirmed-send-address-banner"
import "../app/admin/switch-user-mount"

// Make React available on window
import React from "react"
window.React = React
import ReactDOM from "react-dom"
window.ReactDOM = ReactDOM
